export { default as RulersOutlineIcon } from './RulersOutlineIcon';
